export interface CrudFormMentionItem {
  mentionValues?: string[];
  mentionSupported?: boolean;
  mentionPrefix?: string;
}
